var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save justify-content-end",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
            _c(
              "button",
              { staticClass: "save-button", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-page" }, [
        _c(
          "div",
          { staticClass: "card-page-content input-field" },
          [
            _c("h6", { staticClass: "card-title-text" }, [
              _vm._v("General Information")
            ]),
            _vm._v(" "),
            _c(
              "b-form-group",
              { class: { "error-input": _vm.$v.dataSetup.name.$error } },
              [
                _c("label", [_vm._v("Title")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: { placeholder: "Title" },
                  model: {
                    value: _vm.$v.dataSetup.name.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataSetup.name, "$model", $$v)
                    },
                    expression: "$v.dataSetup.name.$model"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { class: { "error-input": _vm.$v.dataSetup.source.$error } },
              [
                _c("label", [_vm._v("Source")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    options: _vm.sourceOptions,
                    placeholder: "Select Source",
                    "value-format": "object",
                    label: "label"
                  },
                  model: {
                    value: _vm.$v.dataSetup.source.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataSetup.source, "$model", $$v)
                    },
                    expression: "$v.dataSetup.source.$model"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.sourceIsForm
              ? _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input": _vm.$v.dataSetup.table_group.$error
                    }
                  },
                  [
                    _c("label", [_vm._v(" Table Group ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.tableGroupOptions,
                        placeholder: "Select Table Group",
                        "value-format": "object",
                        label: "name"
                      },
                      model: {
                        value: _vm.$v.dataSetup.table_group.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.dataSetup.table_group, "$model", $$v)
                        },
                        expression: "$v.dataSetup.table_group.$model"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sourceIsForm
              ? _c(
                  "b-form-group",
                  { class: { "error-input": _vm.$v.dataSetup.form.$error } },
                  [
                    _c("label", [_vm._v(" Table ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        disabled: !_vm.dataSetup.table_group,
                        options: _vm.tableOptions,
                        placeholder: "Select Table",
                        "value-format": "object",
                        label: "name"
                      },
                      model: {
                        value: _vm.$v.dataSetup.form.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.dataSetup.form, "$model", $$v)
                        },
                        expression: "$v.dataSetup.form.$model"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sourceIsDataset
              ? _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input": _vm.$v.dataSetup.dataset_group.$error
                    }
                  },
                  [
                    _c("label", [_vm._v(" Dataset Group ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.datasetGroupOptions,
                        placeholder: "Select Dataset Group",
                        "value-format": "object",
                        label: "name"
                      },
                      model: {
                        value: _vm.$v.dataSetup.dataset_group.$model,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.$v.dataSetup.dataset_group,
                            "$model",
                            $$v
                          )
                        },
                        expression: "$v.dataSetup.dataset_group.$model"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sourceIsDataset
              ? _c(
                  "b-form-group",
                  { class: { "error-input": _vm.$v.dataSetup.dataset.$error } },
                  [
                    _c("label", [_vm._v(" Dataset ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        disabled: !_vm.dataSetup.dataset_group,
                        options: _vm.datasetOptions,
                        placeholder: "Select Dataset",
                        "value-format": "object",
                        label: "name"
                      },
                      model: {
                        value: _vm.$v.dataSetup.dataset.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.dataSetup.dataset, "$model", $$v)
                        },
                        expression: "$v.dataSetup.dataset.$model"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.sourceIsApi
        ? _c("div", { staticClass: "card-page m__t--25" }, [
            _c("div", { staticClass: "card-page-content input-field" }, [
              _c("h6", { staticClass: "card-title-text" }, [
                _vm._v("Variable")
              ]),
              _vm._v(" "),
              _c(
                "section",
                _vm._l(_vm.dataSetup.column, function(data, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "field-list mb-2" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "5", lg: "5" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c("label", [_vm._v(" Name ")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      "error-required": false,
                                      placeholder: "Enter name here"
                                    },
                                    model: {
                                      value: data.name,
                                      callback: function($$v) {
                                        _vm.$set(data, "name", $$v)
                                      },
                                      expression: "data.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "4", lg: "4" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c("label", [_vm._v(" Data Type ")]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.dataTypeOptions,
                                      placeholder: "Select Data Type",
                                      "error-required": false
                                    },
                                    model: {
                                      value: data.type,
                                      callback: function($$v) {
                                        _vm.$set(data, "type", $$v)
                                      },
                                      expression: "data.type"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "2", lg: "2" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c("label", [_vm._v(" Set Primary Key ")]),
                                  _vm._v(" "),
                                  _c("j-switch", {
                                    on: {
                                      input: function($event) {
                                        _vm.cekPrimaryAvail(index)
                                      }
                                    },
                                    model: {
                                      value: data.is_primary_key,
                                      callback: function($$v) {
                                        _vm.$set(data, "is_primary_key", $$v)
                                      },
                                      expression: "data.is_primary_key"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center cursor-pointer",
                              attrs: { cols: "1", lg: "1" }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-lg fa-trash",
                                on: {
                                  click: function($event) {
                                    _vm.deleteColumn(index)
                                  }
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-add__experience-manager m__b--20",
                  on: { click: _vm.addColumn }
                },
                [
                  _c("img", {
                    staticClass: "m__r--5",
                    attrs: {
                      src: require("@/assets/icon/add.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v("\n        Add Variable\n      ")
                ]
              ),
              _vm._v(" "),
              _vm.formDetail.data_source &&
              _vm.formDetail.data_source.external_url
                ? _c(
                    "div",
                    [
                      _c("h6", { staticClass: "card-title-text" }, [
                        _vm._v("API")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "6" } }, [
                            _c("div", { staticClass: "wrap-external-api" }, [
                              _c("h4", [_vm._v("List Data")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "div-external-api" }, [
                                _c("div", { staticClass: "icon-ext-api" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/new-form-ui/ext-api.svg")
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ext-api-desc" }, [
                                  _c("div", { staticClass: "ext-api-url" }, [
                                    _vm.formDetail.data_source.external_url.list
                                      .method
                                      ? _c("span", { staticClass: "method" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formDetail.data_source
                                                  .external_url.list.method
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formDetail.data_source
                                            .external_url.list.url
                                            ? _vm.formDetail.data_source
                                                .external_url.list.url
                                            : "API Not Configure"
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-btn",
                                      on: {
                                        click: function($event) {
                                          _vm.openExternalUrlConfig("list")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Edit\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "wrap-external-api" }, [
                              _c("h4", [_vm._v("Create Data")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "div-external-api" }, [
                                _c("div", { staticClass: "icon-ext-api" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/new-form-ui/ext-api.svg")
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ext-api-desc" }, [
                                  _c("div", { staticClass: "ext-api-url" }, [
                                    _vm.formDetail.data_source.external_url
                                      .create.method
                                      ? _c("span", { staticClass: "method" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formDetail.data_source
                                                  .external_url.create.method
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formDetail.data_source
                                            .external_url.create.url
                                            ? _vm.formDetail.data_source
                                                .external_url.create.url
                                            : "API Not Configure"
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-btn",
                                      on: {
                                        click: function($event) {
                                          _vm.openExternalUrlConfig("create")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Edit\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "wrap-external-api" }, [
                              _c("h4", [_vm._v("Delete Data")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "div-external-api" }, [
                                _c("div", { staticClass: "icon-ext-api" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/new-form-ui/ext-api.svg")
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ext-api-desc" }, [
                                  _c("div", { staticClass: "ext-api-url" }, [
                                    _vm.formDetail.data_source.external_url
                                      .delete.method
                                      ? _c("span", { staticClass: "method" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formDetail.data_source
                                                  .external_url.delete.method
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formDetail.data_source
                                            .external_url.delete.url
                                            ? _vm.formDetail.data_source
                                                .external_url.delete.url
                                            : "API Not Configure"
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-btn",
                                      on: {
                                        click: function($event) {
                                          _vm.openExternalUrlConfig("delete")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Edit\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "wrap-external-api" }, [
                              _c("h4", [_vm._v("Export Data")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "div-external-api" }, [
                                _c("div", { staticClass: "icon-ext-api" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/new-form-ui/ext-api.svg")
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ext-api-desc" }, [
                                  _c("div", { staticClass: "ext-api-url" }, [
                                    _vm.formDetail.data_source.external_url
                                      .export.method
                                      ? _c("span", { staticClass: "method" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formDetail.data_source
                                                  .external_url.export.method
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formDetail.data_source
                                            .external_url.export.url
                                            ? _vm.formDetail.data_source
                                                .external_url.export.url
                                            : "API Not Configure"
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-btn",
                                      on: {
                                        click: function($event) {
                                          _vm.openExternalUrlConfig("export")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Edit\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "6" } }, [
                            _c("div", { staticClass: "wrap-external-api" }, [
                              _c("h4", [_vm._v("Detail Data")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "div-external-api" }, [
                                _c("div", { staticClass: "icon-ext-api" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/new-form-ui/ext-api.svg")
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ext-api-desc" }, [
                                  _c("div", { staticClass: "ext-api-url" }, [
                                    _vm.formDetail.data_source.external_url
                                      .detail.method
                                      ? _c("span", { staticClass: "method" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formDetail.data_source
                                                  .external_url.detail.method
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formDetail.data_source
                                            .external_url.detail.url
                                            ? _vm.formDetail.data_source
                                                .external_url.detail.url
                                            : "API Not Configure"
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-btn",
                                      on: {
                                        click: function($event) {
                                          _vm.openExternalUrlConfig("detail")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Edit\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "wrap-external-api" }, [
                              _c("h4", [_vm._v("Update Data")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "div-external-api" }, [
                                _c("div", { staticClass: "icon-ext-api" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/new-form-ui/ext-api.svg")
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ext-api-desc" }, [
                                  _c("div", { staticClass: "ext-api-url" }, [
                                    _vm.formDetail.data_source.external_url
                                      .update.method
                                      ? _c("span", { staticClass: "method" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formDetail.data_source
                                                  .external_url.update.method
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formDetail.data_source
                                            .external_url.update.url
                                            ? _vm.formDetail.data_source
                                                .external_url.update.url
                                            : "API Not Configure"
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-btn",
                                      on: {
                                        click: function($event) {
                                          _vm.openExternalUrlConfig("update")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Edit\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "wrap-external-api" }, [
                              _c("h4", [_vm._v("Import Data")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "div-external-api" }, [
                                _c("div", { staticClass: "icon-ext-api" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/new-form-ui/ext-api.svg")
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ext-api-desc" }, [
                                  _c("div", { staticClass: "ext-api-url" }, [
                                    _vm.formDetail.data_source.external_url
                                      .import.method
                                      ? _c("span", { staticClass: "method" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formDetail.data_source
                                                  .external_url.import.method
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formDetail.data_source
                                            .external_url.import.url
                                            ? _vm.formDetail.data_source
                                                .external_url.import.url
                                            : "API Not Configure"
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit-btn",
                                      on: {
                                        click: function($event) {
                                          _vm.openExternalUrlConfig("import")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Edit\n                  "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.sourceIsDataset
        ? _c("div", { staticClass: "card-page m__t--25" }, [
            _c(
              "div",
              { staticClass: "card-page-content input-field general-info" },
              [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between" },
                  [
                    _c("h6", { staticClass: "card-title-text m-0" }, [
                      _vm._v("Digital Signature")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      [
                        _c("j-switch", {
                          model: {
                            value: _vm.dataSetup.isUseDigitalSignature,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dataSetup,
                                "isUseDigitalSignature",
                                $$v
                              )
                            },
                            expression: "dataSetup.isUseDigitalSignature"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dataSetup.isUseDigitalSignature
                  ? _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.thirdPartyConn.$error
                        }
                      },
                      [
                        _c("label", [_vm._v("Third Party")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.listThirdParty,
                            placeholder: "Select Third Party",
                            "value-format": "object",
                            label: "label"
                          },
                          model: {
                            value: _vm.$v.dataSetup.thirdPartyConn.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.thirdPartyConn,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.thirdPartyConn.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.isUseDigitalSignature
                  ? _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.attachSigned.$error
                        }
                      },
                      [
                        _c("label", [_vm._v("Attach signed document")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.columnOptions,
                            placeholder: "Select Column",
                            "value-format": "object",
                            label: "label"
                          },
                          model: {
                            value: _vm.$v.dataSetup.attachSigned.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.attachSigned,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.attachSigned.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.isUseDigitalSignature
                  ? _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.attachNotSigned.$error
                        }
                      },
                      [
                        _c("label", [_vm._v("Attach not signed document")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.columnOptions,
                            placeholder: "Select Column",
                            "value-format": "object",
                            label: "label"
                          },
                          model: {
                            value: _vm.$v.dataSetup.attachNotSigned.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.attachNotSigned,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.attachNotSigned.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceIsApi && _vm.isOpenExternalApiConfig
        ? _c("external-api-form", {
            ref: "externalApiConfig",
            attrs: {
              id: "externalApiConfig",
              "type-tab": _vm.typeTab,
              "list-variable": _vm.dataSetup.column,
              "is-multiple-form": _vm.isMultipleForm
            },
            on: {
              "close-config": function($event) {
                _vm.toggleExternalApiConfig(false)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6fa5c06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6fa5c06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jInformationView.vue
// module id = null
// module chunks = 